import axios from 'axios';
import {errors as E} from 'common/constants/errors';

const defaultRequestValues = {
  cityID: -1,
  streetID: -1,
  gush: '',
  helka: '',
  fromDate: '',
  toDate:'',
  requestedPageNumber: 0,
};

export const getStep9Grid = ({
                               actions: {
                                 pending,
                                 success,
                                 failure,
                                 setPage
                               },
                               api,
                               defaultValues = defaultRequestValues
                             }) => values => dispatch => {
  dispatch({
    type: pending
  });

  const data = {
    ...defaultValues,
    ...values,
  };

  return axios.post(api, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      const {gridData, totalPageCount, currentPageNumber, totalResultCount} = body;
      dispatch({
        type: success,
        payload: {list: gridData, totalPages: totalPageCount, totalResultCount},
      });
      dispatch({
        type: setPage,
        payload: {page: currentPageNumber}
      });
    })
    .catch((err) => {
      dispatch({
        type: failure,
        payload: err.message
      });
    });
};

export const getStep9GridTab1 = ({
                               actions: {
                                 pending,
                                 success,
                                 failure,
                                 setPage
                               },
                               api
                             }) => values => dispatch => {
  dispatch({
    type: pending
  });

  const data = {
    ...values,
  };

  return axios.post(api, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      const {gridData, totalPageCount, currentPageNumber, totalResultCount} = body;
      dispatch({
        type: success,
        payload: {list: gridData, totalPages: totalPageCount, totalResultCount},
      });
      dispatch({
        type: setPage,
        payload: {page: currentPageNumber}
      });
    })
    .catch((err) => {
      dispatch({
        type: failure,
        payload: err.message
      });
    });
};
